import { area as turfArea } from '@turf/turf';
import { Feature } from 'ol';
import { GeoJSON } from 'ol/format';
import { GeoJSONMultiPolygon, GeoJSONPolygon } from 'ol/format/GeoJSON';

const geoJSON = new GeoJSON({ featureProjection: 'EPSG:3857' });

/**
 * Calcola l'area di una feature arrotondandola.
 */
export function getRoundedFeatureArea(feature: Feature) {
  const geometry = feature.getGeometry();
  if (!geometry) return 0;

  const area = turfArea(
    geoJSON.writeFeatureObject(feature).geometry as
      | GeoJSONPolygon
      | GeoJSONMultiPolygon,
  );
  return Math.round((area + Number.EPSILON) * 100) / 100;
}
